import React, { useState } from "react"
import { navigate } from '@reach/router'
import moment from "moment"
import pic02 from '../assets/images/pic02.jpg'
import { slug } from "../lib/utils"
import { useScreen } from "../lib/hooks"


const EventFeed = ( { events } ) => {

    const isMobile = useScreen()
    
    const INCREMENT = isMobile ? 2 : 3
    const [ eventCursor, setEventCursor ] = useState( 0 )
    const [ maxEventsShown, setmaxEventsShown ] = useState( INCREMENT )

    const incrementMaxEvents = ( events ) => {
        if( events.length >= maxEventsShown > events.length - INCREMENT ) {
            setmaxEventsShown( events.length )
        }else if( maxEventsShown < events.length ){
            setmaxEventsShown( maxEventsShown + INCREMENT )
        }else{
            setmaxEventsShown( INCREMENT )    
        }
    }

    const showNextEvents = ( events ) => {
        if( eventCursor <= events.length - INCREMENT ){
            setEventCursor( eventCursor + INCREMENT )
        }else{
            setEventCursor( events.length - INCREMENT )
        }
    }

    const showPreviousEvents = ( events ) => {
        if( eventCursor >= INCREMENT ){
            setEventCursor( eventCursor - INCREMENT )
        }else{
            setEventCursor( 0 )
        }
    }


    const isToday = ( date ) => {  
        const now = new Date()
      
        return date.getDate() === now.getDate() &&
            date.getMonth() === now.getMonth() &&
            date.getFullYear() === now.getFullYear()
      }
    
    const isTomorrow = ( date ) => {  
        const now = new Date()
        now.setDate( now.getDate() + 1 )
    
        return date.getDate() === now.getDate() &&
            date.getMonth() === now.getMonth() &&
            date.getFullYear() === now.getFullYear()
    }

    const removeDuplicates = ( arr, entry ) => {
        const dupArr = []
        const finalArr = []
        arr.forEach( item => {
            if( item[entry] ){
                if( !dupArr.includes( item[entry] ) ){
                    dupArr.push( item[entry] )
                    finalArr.push( item )
                }
            } else {
                throw 'Entry is not a key in the object'
            }
        } )
        return finalArr
    }
    // const filteredEvents = removeDuplicates( events, 'title' )
    let sortedEvents = events.map( event => {
        if( event.repeated && event.start < new Date() ) {
            const d = new Date()
            const dayOfWeek = event.start.getDay()
            d.setDate( d.getDate() + ( dayOfWeek + 7 - d.getDay() ) % 7 ) 
            d.setHours( event.start.getHours() )
            d.setMinutes( event.start.getMinutes() )
            d.setFullYear( d.getFullYear() )
            return {
                ...event,
                start: d
            }
        }else{
            return event
        }
    } )

    sortedEvents = sortedEvents.filter( event => event.start.getTime() >= ( new Date() ).getTime() )
    sortedEvents.sort( ( a, b ) => a.start.getTime() - b.start.getTime() )
    const displayedEvents = sortedEvents.slice( eventCursor, eventCursor + INCREMENT )
    const showMoreEventsText = maxEventsShown >= sortedEvents.length ? "Show Less" : "Show More"
    let latestMonth = null

    const FeedScrollButton = ( { children, onClick } ) => <button className="button event-button" onClick={onClick}>{children}</button>
    const DesktopFeedScrollButton = ( { children, onClick, position, visibilityCondition } ) => {
        return (
        <button 
            disabled={!visibilityCondition} 
            className={`button event-button desktop ${position}`} 
            onClick={onClick}
            style={{ visibility: visibilityCondition ? 'visible' : 'hidden' }}
        >
        {children}     
        </button>
    )}

    return (
        <section id="event-feed" className="main style1 special"> 
            <div className="col-12">
                <header className="major">
                    <h2>Upcoming Events</h2>
                </header>
            </div>
            <div className={'event-feed-container'}>
                {/* {isMobile &&
                <div className="col-12 actions" style={{ paddingTop: '2em' }}>
                    {eventCursor > 0 && <FeedScrollButton onClick={() => showPreviousEvents(sortedEvents)}>
                        &lt;
                    </FeedScrollButton>}
                    {eventCursor < sortedEvents.length - INCREMENT && <FeedScrollButton onClick={() => showNextEvents(sortedEvents)}>
                        &gt;
                    </FeedScrollButton>}
                </div>
                }    */}
              
                <div className="actions">
                    <DesktopFeedScrollButton visibilityCondition={eventCursor > 0} onClick={() => showPreviousEvents( sortedEvents )} position="left">
                    {/* <button disabled={!(eventCursor > 0)} className="button transparent-button" style={{ backgroundColor: 'white', color: 'gray', marginRight: '1em', fontWeight: 'bold', visibility: eventCursor > 0 ? 'visible' : 'hidden' }} onClick={() => showPreviousEvents(sortedEvents)}> */}
                        &lt;
                    {/* </button> */}
                    </DesktopFeedScrollButton>
                </div>
                
                {displayedEvents.map( event => {
                    const showMonth = latestMonth !== event.start.getMonth()
                    latestMonth = event.start.getMonth()

                    let eventTime = moment( event.start ).format( 'ddd DD MMM YYYY' )
                    if( isToday( event.start ) ){
                        eventTime = "Today"
                    }else if( isTomorrow( event.start ) ){
                        eventTime = "Tomorrow"
                    }
                let description = ''
                if ( event.description ) {
                    if ( event.description.length > 100 )
                        description =  event.description.substring( 0, 100 ) + '...'
                    else
                        description = event.description
                }
                    return (
                        <>
                        {/* {showMonth && <div data-aos='fade-up' data-aos-duration='800' className="event-feed-month">{moment(event.start).format('MMMM')}</div>} */}
                        <div key={event.id} data-aos='fade-in' data-aos-duration='800' className="event-feed-item" onClick={ () => navigate( `/whats-on/${slug( event.title )}`, { state: { title: event.title, extra: { ...event } } } )}>
                            <img className='event-feed-img' src={event.image || pic02} alt="" />
                            <h3 style={{ fontWeight: '500', margin: '10px 0' }}>{event.title}</h3>
                            <div className='event-feed-item-info'>
                                <div><b>{eventTime}</b> @ {moment( event.start ).format( 'HH:mm' )} - {moment( event.end ).format( 'HH:mm' )}</div>
                                <div>{event.location || "Church Building"}</div>
                                <span style={{ fontSize: '0.75em' }}>
                                    <p>{description}</p>
                                </span>
                            </div>
                        </div>
                        </>
                    )
                } )}
                <div className="actions">
                    <DesktopFeedScrollButton visibilityCondition={eventCursor < sortedEvents.length - INCREMENT} onClick={() => showNextEvents( sortedEvents )} position="right">

                    {/* <button disabled={!(eventCursor < sortedEvents.length - INCREMENT)} className="button transparent-button" style={{ backgroundColor: 'white', color: 'gray', marginLeft: '1em', fontWeight: 'bold', visibility: eventCursor < sortedEvents.length - INCREMENT ? 'visible' : 'hidden' }} onClick={() => showNextEvents(sortedEvents)}> */}
                        &gt;
                    {/* </button> */}
                    </DesktopFeedScrollButton>
                </div>
            </div>
            {/* <div className="col-12 actions" style={{ paddingTop: '2em' }}><button className="button transparent-button" style={{ color: 'gray' }} onClick={() => incrementMaxEvents(sortedEvents)}>{showMoreEventsText}</button></div> */}
        </section>
    )
}

export default EventFeed